import { createSelector } from 'reselect'

export const selectAppSettings = store=>store.appSettings

const hostDnsSelector = (store) => store.hostDns

export const selectSignalRConfig = createSelector(
    [selectAppSettings, hostDnsSelector],
    (appSettings, hostDns) => {
        const path = appSettings?.Networking?.Urls?.avapi?.SignalR
        if (!path) return null
        const base = hostDns?.avApi || '/avapi'
        return { url: `${base}${path.startsWith('/') ? '' : '/'}${path}` }
    }
)